import { render } from "./ExternalParties.vue?vue&type=template&id=0e920b4e&scoped=true"
import script from "./ExternalParties.vue?vue&type=script&lang=js"
export * from "./ExternalParties.vue?vue&type=script&lang=js"

import "./ExternalParties.vue?vue&type=style&index=0&id=0e920b4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e920b4e"]])

export default __exports__